module.exports = __webpack_public_path__ + "img/profile-man-10-min.c9f89bd5.jpg";